<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchTypologySizes(typologyId) {
    return axios.get(`tipologias/${typologyId}/typology_sizes`, AS.getDefaultHeaders());
  },
  createTypologySize(typologyId, typologySizeParams) {
    return axios.post(`tipologias/${typologyId}/typology_sizes`,
      { typology_size: typologySizeParams },
      AS.getDefaultHeaders());
  },
  updateTypologySize(typologyId, params) {
    return axios.patch(`tipologias/${typologyId}/typology_sizes/${params.id}`,
      { typology_size: params }, AS.getDefaultHeaders());
  },
  destroy(typologyId, id) {
    return axios.delete(`tipologias/${typologyId}/typology_sizes/${id}`, AS.getDefaultHeaders());
  },
};
</script>
